import { useContext } from 'react';
import { PermissionsContext } from '../context/PermissionsContext';

export function usePermissions() {
  const { permissions, overrides, loading, refresh } = useContext(PermissionsContext);

  const canView = (page: string): boolean | undefined => {
    return permissions[page]?.view;
  };

  const canCreate = (page: string): boolean | undefined => {
    return permissions[page]?.create;
  };

  const canUpdate = (page: string): boolean | undefined => {
    return permissions[page]?.update;
  };

  const canDelete = (page: string): boolean | undefined => {
    return permissions[page]?.delete;
  };

  const canExport = (page: string): boolean | undefined => {
    return permissions[page]?.export;
  };

  const hasRoleOverride = (page: string): boolean => {
    return overrides.role.includes(page);
  };

  const hasUserOverride = (page: string): boolean => {
    return overrides.user.includes(page);
  };

  return {
    canView,
    canCreate,
    canUpdate,
    canDelete,
    canExport,
    hasRoleOverride,
    hasUserOverride,
    loading,
    refresh,
    permissions,
  };
}
